import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, ValidateNested } from 'class-validator';
import { WebMerchantExposeGroup, WebStoreExposeGroup } from '../interface';
import { UpdateWebMerchantAppLoginRegisterScreenDto } from './UpdateWebMerchantAppLoginRegisterScreenDto';
import { UpdateWebMerchantAppSharedComponentsDto } from './UpdateWebMerchantAppSharedComponentsDto';
import { UpdateWebMerchantCartDto } from './UpdateWebMerchantCartDto';
import { UpdateWebMerchantCategoriesNavBarDto } from './UpdateWebMerchantCategoriesNavBarDto';
import { UpdateWebMerchantCategoryMenuItemsGroupDto } from './UpdateWebMerchantCategoryMenuItemsGroupDto';
import { UpdateWebMerchantCustomNavigationLinkDto } from './UpdateWebMerchantCustomNavigationLinkDto';
import { UpdateWebMerchantFooterDto } from './UpdateWebMerchantFooterDto';
import { UpdateWebMerchantHeaderDto } from './UpdateWebMerchantHeaderDto';
import { UpdateWebMerchantHeaderLogoBlockDto } from './UpdateWebMerchantHeaderLogoBlockDto';
import { UpdateWebMerchantHeroBlockDto } from './UpdateWebMerchantHeroBlockDto';
import { UpdateWebMerchantItemModalDto } from './UpdateWebMerchantItemModalDto';
import { UpdateWebMerchantItemScheduleBlockDto } from './UpdateWebMerchantItemScheduleBlockDto';
import { UpdateWebMerchantLoyaltyBadgeDto } from './UpdateWebMerchantLoyaltyBadgeDto';
import { UpdateWebMerchantMenuConceptsBarDto } from './UpdateWebMerchantMenuConceptsBarDto';
import { UpdateWebMerchantMenuItemCardDto } from './UpdateWebMerchantMenuItemCardDto';
import { UpdateWebMerchantMenuItemCardMobileDto } from './UpdateWebMerchantMenuItemCardMobileDto';
import { UpdateWebMerchantMenuListDto } from './UpdateWebMerchantMenuListDto';
import { UpdateWebMerchantOrderCompleteScreenDto } from './UpdateWebMerchantOrderCompleteScreenDto';
import { UpdateWebMerchantOrderConfirmationDto } from './UpdateWebMerchantOrderConfirmationDto';
import { UpdateWebMerchantOrderReminderBannerDto } from './UpdateWebMerchantOrderReminderBannerDto';
import { UpdateWebMerchantOrderScreenDto } from './UpdateWebMerchantOrderScreenDto';
import { UpdateWebMerchantOrderSetupStatusBarDto } from './UpdateWebMerchantOrderSetupStatusBarDto';
import { UpdateWebMerchantOrderToTableBarDto } from './UpdateWebMerchantOrderToTableBarDto';
import { UpdateWebMerchantPaymentScreenDto } from './UpdateWebMerchantPaymentScreenDto';
import { UpdateWebMerchantPreviousOrdersListDto } from './UpdateWebMerchantPreviousOrdersListDto';
import { UpdateWebMerchantPromoPopupDto } from './UpdateWebMerchantPromoPopupDto';
import { UpdateWebMerchantPromotionsBarDto } from './UpdateWebMerchantPromotionsBarDto';
import { UpdateWebMerchantSocialMediaDto } from './UpdateWebMerchantSocialMediaDto';
import { UpdateWebMerchantTopSellingItemsSliderDto } from './UpdateWebMerchantTopSellingItemsSliderDto';
export class UpdateWebStoreComponentsDto {
    constructor() {
        this.customNavigationLinks = [];
    }
}
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantHeaderDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantHeaderDto),
    __metadata("design:type", UpdateWebMerchantHeaderDto)
], UpdateWebStoreComponentsDto.prototype, "header", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantHeaderLogoBlockDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantHeaderLogoBlockDto),
    __metadata("design:type", UpdateWebMerchantHeaderLogoBlockDto)
], UpdateWebStoreComponentsDto.prototype, "headerLogoBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantFooterDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantFooterDto),
    __metadata("design:type", UpdateWebMerchantFooterDto)
], UpdateWebStoreComponentsDto.prototype, "footer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantSocialMediaDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantSocialMediaDto),
    __metadata("design:type", UpdateWebMerchantSocialMediaDto)
], UpdateWebStoreComponentsDto.prototype, "socialMedia", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantPromotionsBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantPromotionsBarDto),
    __metadata("design:type", UpdateWebMerchantPromotionsBarDto)
], UpdateWebStoreComponentsDto.prototype, "promotionsBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantHeroBlockDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantHeroBlockDto),
    __metadata("design:type", UpdateWebMerchantHeroBlockDto)
], UpdateWebStoreComponentsDto.prototype, "heroBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantLoyaltyBadgeDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantLoyaltyBadgeDto),
    __metadata("design:type", UpdateWebMerchantLoyaltyBadgeDto)
], UpdateWebStoreComponentsDto.prototype, "loyaltyBadge", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantOrderSetupStatusBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantOrderSetupStatusBarDto),
    __metadata("design:type", UpdateWebMerchantOrderSetupStatusBarDto)
], UpdateWebStoreComponentsDto.prototype, "orderSetupStatusBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantOrderToTableBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantOrderToTableBarDto),
    __metadata("design:type", UpdateWebMerchantOrderToTableBarDto)
], UpdateWebStoreComponentsDto.prototype, "orderToTableBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantAppLoginRegisterScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantAppLoginRegisterScreenDto),
    __metadata("design:type", UpdateWebMerchantAppLoginRegisterScreenDto)
], UpdateWebStoreComponentsDto.prototype, "loginRegisterScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantAppSharedComponentsDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantAppSharedComponentsDto),
    __metadata("design:type", UpdateWebMerchantAppSharedComponentsDto)
], UpdateWebStoreComponentsDto.prototype, "sharedComponents", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantMenuConceptsBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantMenuConceptsBarDto),
    __metadata("design:type", UpdateWebMerchantMenuConceptsBarDto)
], UpdateWebStoreComponentsDto.prototype, "menuConceptsBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantCategoriesNavBarDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantCategoriesNavBarDto),
    __metadata("design:type", UpdateWebMerchantCategoriesNavBarDto)
], UpdateWebStoreComponentsDto.prototype, "categoriesNavBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantItemModalDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantItemModalDto),
    __metadata("design:type", UpdateWebMerchantItemModalDto)
], UpdateWebStoreComponentsDto.prototype, "itemModal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantMenuItemCardDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantMenuItemCardDto),
    __metadata("design:type", UpdateWebMerchantMenuItemCardDto)
], UpdateWebStoreComponentsDto.prototype, "menuItemCard", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantMenuItemCardMobileDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantMenuItemCardMobileDto),
    __metadata("design:type", UpdateWebMerchantMenuItemCardMobileDto)
], UpdateWebStoreComponentsDto.prototype, "menuItemCardMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantMenuListDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantMenuListDto),
    __metadata("design:type", UpdateWebMerchantMenuListDto)
], UpdateWebStoreComponentsDto.prototype, "menuList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantCategoryMenuItemsGroupDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantCategoryMenuItemsGroupDto),
    __metadata("design:type", UpdateWebMerchantCategoryMenuItemsGroupDto)
], UpdateWebStoreComponentsDto.prototype, "categoryItemsGroup", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantPromoPopupDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantPromoPopupDto),
    __metadata("design:type", UpdateWebMerchantPromoPopupDto)
], UpdateWebStoreComponentsDto.prototype, "promoPopup", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantTopSellingItemsSliderDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantTopSellingItemsSliderDto),
    __metadata("design:type", UpdateWebMerchantTopSellingItemsSliderDto)
], UpdateWebStoreComponentsDto.prototype, "topSellingItemsSlider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantPreviousOrdersListDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantPreviousOrdersListDto),
    __metadata("design:type", UpdateWebMerchantPreviousOrdersListDto)
], UpdateWebStoreComponentsDto.prototype, "previousOrdersList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantOrderReminderBannerDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantOrderReminderBannerDto),
    __metadata("design:type", UpdateWebMerchantOrderReminderBannerDto)
], UpdateWebStoreComponentsDto.prototype, "orderReminderBanner", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantCartDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantCartDto),
    __metadata("design:type", UpdateWebMerchantCartDto)
], UpdateWebStoreComponentsDto.prototype, "cartScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantOrderScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantOrderScreenDto),
    __metadata("design:type", UpdateWebMerchantOrderScreenDto)
], UpdateWebStoreComponentsDto.prototype, "orderScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantPaymentScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantPaymentScreenDto),
    __metadata("design:type", UpdateWebMerchantPaymentScreenDto)
], UpdateWebStoreComponentsDto.prototype, "paymentScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantOrderConfirmationDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantOrderConfirmationDto),
    __metadata("design:type", UpdateWebMerchantOrderConfirmationDto)
], UpdateWebStoreComponentsDto.prototype, "orderConfirmationScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantOrderCompleteScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantOrderCompleteScreenDto),
    __metadata("design:type", UpdateWebMerchantOrderCompleteScreenDto)
], UpdateWebStoreComponentsDto.prototype, "orderCompleteScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantItemScheduleBlockDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => UpdateWebMerchantItemScheduleBlockDto),
    __metadata("design:type", UpdateWebMerchantItemScheduleBlockDto)
], UpdateWebStoreComponentsDto.prototype, "itemScheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => UpdateWebMerchantCustomNavigationLinkDto, isArray: true, default: [] }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    Type(() => UpdateWebMerchantCustomNavigationLinkDto),
    __metadata("design:type", Array)
], UpdateWebStoreComponentsDto.prototype, "customNavigationLinks", void 0);
//# sourceMappingURL=UpdateWebStoreComponentsDto.js.map